export default "#squares {\n    display: inline-block;\n    justify-content: center;\n}\n";